// extracted by mini-css-extract-plugin
export var actions = "_52-0";
export var actionsContainer = "_52-7";
export var border = "_52-1";
export var childFullHeight = "_52-f";
export var collapse = "_52-2";
export var content = "_52-a";
export var contentChild = "_52-e";
export var fullscreen = "_52-c";
export var hasLeftRadius = "_52-k";
export var headerContainer = "_52-3";
export var headerRow = "_52-5";
export var hidePadding = "_52-b";
export var navCollapsedGap = "_52-l";
export var noScrollX = "_52-m";
export var noScrollY = "_52-n";
export var noTopPadding = "_52-i";
export var optOutTopPadding = "_52-d";
export var pageMain = "_52-j";
export var pageOuter = "_52-g";
export var pagePadding = "_52-8";
export var pageScroll = "_52-9";
export var profile = "_52-o";
export var profileContainer = "_52-p";
export var profileImage = "_52-q";
export var profileMain = "_52-r";
export var profileSubtitle = "_52-t";
export var profileTitle = "_52-s";
export var showLeftPadding = "_52-h";
export var tabsPortalSlot = "_52-6";
export var tabsWrapper = "_52-4";
export var title = "_52-u";